import { Typography } from '@mui/material';
import Chart from 'react-apexcharts';

const DoughnutChart: React.FC<{ data: number[]; title: string }> = ({ data, title }) => {
  const options = {
    series: data,
    legend: { show: false },
    labels: ['Approved', 'Draft', 'Not Started', 'Submitted', 'Freeze'],
    colors: [
      'rgb(0, 227, 150)',
      'rgb(254, 176, 25)',
      'rgb(255, 69, 96)',
      'rgb(0, 143, 251)',
      'rgb(174, 174, 174)',
    ],

    plotOptions: {
      pie: {
        expandOnClick: false,
        donut: {
          size: '55px',
          labels: {
            show: true,
            total: {
              show: true,
              showAlways: true,
            },
          },
        },
      },
    },
  };
  return (
    <>
      <Chart type="donut" height={300} width="100%" options={options} series={data} />
      <Typography variant="subtitle2" display={'flex'} justifyContent={'center'} fontWeight={600}>
        {title}
      </Typography>
    </>
  );
};

export default DoughnutChart;
